import { T } from '@tribeplatform/react-components/i18n'

import { BlockBadge } from './BlockBadge.js'

interface Props {
  releaseMessage: string
}

export const NewBlockBadge = ({ releaseMessage }: Props) => {
  return (
    <BlockBadge
      message={releaseMessage}
      variant="positive"
      text={<T id="Generics.New" defaultMessage="New" />}
    />
  )
}
